function customKit() {
  const isDebug = false;
  const baseStyles = [
    'color: #fff',
    'background-color: #1779E1',
    'padding: 2px 8px',
    'border-radius: 4px'
  ].join(';');

  function consoleLog() {
    if (window.console && isDebug === true) {
      console.log('%cDD-DEBUG', baseStyles, ...Array.prototype.slice.call(arguments));
    }
  }

  consoleLog('customKit init');

  const canvas = document.querySelector('#ck-canvas');
  const fileInput = document.querySelector('#custom_photo_init');
  const ckSection = document.querySelector('.ck-section');
  const kitForm = document.querySelector('.ck-section form[data-type="add-to-cart-form"]');

  if (!canvas || !fileInput || !ckSection) return;

  const imgUploaded = new Image();
  imgUploaded.src = '';
  const imgPixel = new Image();
  imgPixel.src = canvas.getAttribute('data-pixel-square-src');
  let uploadImg = '';

  function getCkOptionValue(position) {
    const optionRoot = ckSection.querySelector(`[data-ck-option-position="${position}"]`);
    if (!optionRoot) return '';

    const checked = optionRoot.querySelector('input:checked');
    if (checked) return checked.value;

    const select = optionRoot.querySelector('select');
    if (select) return select.value;

    return '';
  }

  function getBuyButtons() {
    return ckSection.querySelector('.product-form__buttons');
  }

  document.querySelectorAll('.ck-trigger-upload').forEach((e) => {
    e.addEventListener('click', function (event) {
      consoleLog('ck-trigger-upload clicked');
      event.preventDefault();

      if (window.aiUrl && window.jQuery) {
        consoleLog('AI URL detected', window.aiUrl);
        window.jQuery('.ai-tos-trigger').trigger('click');
        return;
      }

      fileInput.click();
    });
  });

  if (window.jQuery) {
    window.jQuery('.ai-tos-agree').on('click', function () {
      const tos = document.querySelector('#ai-tos');
      if (tos) tos.setAttribute('open', 'true');
      fileInput.dispatchEvent(new Event('change'));

      const properties = document.querySelector('.custom-product-properties');
      if (properties) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[AI-Generated]';
        input.value = 'Yes';
        properties.appendChild(input);
      }

      window.jQuery('.ai-tos-trigger').trigger('click');
    });
  }

  fileInput.addEventListener('change', async function () {
    consoleLog('custom_photo_init changed');

    let uploadedFile;

    if (this.files && this.files[0]) {
      uploadedFile = this.files[0];
    }

    if (window.aiUrl) {
      const response = await fetch(window.aiUrl);
      const data = await response.blob();
      const file = new File([data], 'generated.png', { type: 'image/png' });
      const container = new DataTransfer();
      container.items.add(file);
      this.files = container.files;
      window.aiFile = file;
      uploadedFile = window.aiFile;
    }

    consoleLog('Uploaded file is', uploadedFile);

    if (!uploadedFile) {
      syncBuyButtonsVisibility();
      return;
    }

    if (uploadedFile.size > 20 * 1024 * 1024) {
      alert('Image size limitation: No more than 20MB!');
      fileInput.value = '';
      syncBuyButtonsVisibility();
      return;
    }

    document.querySelector('.ck_upload_box')?.classList.add('ck-hide');
    ckSection.classList.remove('ck-hide');
    refreshKitUid();
    syncBuyButtonsVisibility();

    const loading = document.querySelector('.ck-upload-loading');
    if (loading) {
      loading.hidden = false;
      loading.style.display = 'block';
    }

    getImgBase64Data(uploadedFile, function (res) {
      consoleLog('Image converted to base64');
      uploadImg = res;
      setTimeout(function () {
        updateDimensions();
      }, 200);
    });

    const canvasY = ckSection.getBoundingClientRect().top + window.scrollY - 230;
    window.scrollTo({
      top: canvasY,
      left: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto'
    });
  });

  const abDrillFormInput = document.querySelector('#custom_photo_ab_drill');
  const abDrillCheckbox = document.querySelector('input[name="ab-drills"]');
  if (abDrillFormInput && abDrillCheckbox) {
    abDrillCheckbox.addEventListener('change', function () {
      consoleLog('AB-drills changed', this.checked);
      abDrillFormInput.value = this.checked ? 'Yes' : 'No';
    });
  }

  function updateDimensions() {
    consoleLog('updateDimensions');

    const inputDimensions = getCkOptionValue(1);
    const inputDiamondSize = getCkOptionValue(2);

    imgPixel.src = canvas.getAttribute('data-pixel-square-src');
    if (inputDiamondSize && inputDiamondSize === 'Round') {
      imgPixel.src = canvas.getAttribute('data-pixel-circle-src');
    }

     // dimensions
    const size = inputDimensions || '';
    const width = size.replace('cm', '').split('x')[0];
    const height = size.replace('cm', '').split('x')[1];
    if (!width || !height) return;

    canvas.width = width * 38;
    canvas.height = height * 38;

    canvas.style.visibility = 'hidden';
    setTimeout(function () {
      updateCanvas();
    }, 200);
  }

  ckSection.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects')) return;
    consoleLog('Custom kit option changed');
    updateDimensions();
    syncBuyButtonsVisibility();
  });

  document.querySelector('#zoomIn')?.addEventListener('click', () => {
    zoomInstance.zoomTo(canvas.width / 2, canvas.height / 2, 1.5);
  });
  document.querySelector('#zoomIn')?.addEventListener('touchstart', () => {
    zoomInstance.zoomTo(canvas.width / 2, canvas.height / 2, 1.5);
  });
  document.querySelector('#zoomOut')?.addEventListener('click', () => {
    zoomInstance.zoomTo(canvas.width / 2, canvas.height / 2, 0.75);
  });
  document.querySelector('#zoomOut')?.addEventListener('touchstart', () => {
    zoomInstance.zoomTo(canvas.width / 2, canvas.height / 2, 0.75);
  });

  var zoomInstance = typeof panzoom === 'function'
    ? panzoom(canvas, {
        maxZoom: 10,
        minZoom: 1,
        bounds: true,
        boundsPadding: 1,
        zoomDoubleClickSpeed: 1
      })
    : { zoomTo: function () {} };

  function getImgBase64Data(file, callback) {
    var reader = new FileReader();
    reader.onload = function (e) {
      callback(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  function updateCanvas() {
    consoleLog('updateCanvas');

    var scale = {
      value: 10,
    };
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = false;
    imgUploaded.onload = function () {
      var ratio;
      var cw;
      var ch;
      if (imgUploaded.width > imgUploaded.height) {
        ratio = imgUploaded.width / imgUploaded.height;
        cw = canvas.height * ratio;
        ch = canvas.height;
      } else {
        ratio = imgUploaded.height / imgUploaded.width;
        cw = canvas.width;
        ch = canvas.width * ratio;
      }
      var sw = (cw / scale.value) >> 0;
      var sh = (ch / scale.value) >> 0;
      ctx.drawImage(imgUploaded, 0, 0, sw, sh);
      ctx.lineWidth = 0.5;
      var p = 1;
      for (var x = 0; x <= canvas.width; x += 10) {
        ctx.moveTo(x, p);
        ctx.lineTo(x, canvas.height);
      }
      for (var x = 0; x <= ch; x += 10) {
        ctx.moveTo(0, p + x);
        ctx.lineTo(cw, 0 + x);
      }
      var xOffset = cw > canvas.width ? (canvas.width - cw) / 2 : 0;
      var yOffset = ch > canvas.height ? (canvas.height - ch) / 2 : 0;
      yOffset = Math.ceil(yOffset / 10) * 10;
      xOffset = Math.ceil(xOffset / 10) * 10;
      ctx.drawImage(canvas, 0, 0, sw, sh, xOffset, yOffset, cw, ch);
      setTimeout(function () {
        var pat = ctx.createPattern(imgPixel, 'repeat');
        ctx.rect(0, 0, cw, ch);
        ctx.strokeStyle = 'rgba(0,0,0,0.1)';
        ctx.fillStyle = pat;
        ctx.fill();
        canvas.style.visibility = 'visible';
        const loading = document.querySelector('.ck-upload-loading');
        if (loading) {
          loading.hidden = true;
          loading.style.display = 'none';
        }
      }, 800);
    };
    imgUploaded.src = uploadImg;
    if (imgUploaded.complete) {
      imgUploaded.onload();
    }
  }

  function isVariantUnavailable() {
    const variantInput = kitForm?.querySelector('.product-variant-id');
    return Boolean(variantInput && variantInput.disabled);
  }

  function hasUploadedPhoto() {
    return Boolean(fileInput.files && fileInput.files[0]);
  }

  function refreshKitUid() {
    const uidInput = kitForm?.querySelector('#custom_photo_uid');
    if (uidInput) {
      uidInput.value = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }
  }

  function syncBuyButtonsVisibility() {
    const purchase = ckSection.querySelector('.ck-purchase');
    const buyButtons = getBuyButtons();
    const hint = purchase?.querySelector('.ck-purchase__hint');
    const submit = buyButtons?.querySelector('[name="add"]');
    const termsAccepted = document.querySelectorAll('.acceptTerms input:not(:checked)').length === 0;
    const variantUnavailable = isVariantUnavailable();
    const photoReady = hasUploadedPhoto();

    purchase?.classList.toggle('ck-purchase--locked', !termsAccepted || !photoReady);

    if (hint) {
      hint.hidden = termsAccepted && photoReady;
    }

    if (submit) {
      submit.disabled = variantUnavailable || !termsAccepted || !photoReady;
    }
  }

  if (kitForm) {
    kitForm.addEventListener(
      'submit',
      function (event) {
        if (!hasUploadedPhoto()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          alert('Please upload a photo before adding this kit to your cart.');
          syncBuyButtonsVisibility();
          return;
        }

        refreshKitUid();
      },
      true
    );
  }

  syncBuyButtonsVisibility();

  document.querySelectorAll('.acceptTerms input').forEach(function (input) {
    input.addEventListener('change', syncBuyButtonsVisibility);
  });
}

window.mobileCheck = function () {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

function mobileChangeCustomKitElementPlacement() {
  if (window.mobileCheck() === false) return;

  const whereCustomStepsGo = document.querySelector('.product-info__custom-kit .ck-trigger__subtext');
  const customSteps = document.querySelector('.custom--steps-1-3');
  const customDesc = document.querySelector('.product-info__custom-kit .product-info__description');
  const productDescription = document.querySelector('.product__info-container .product-block-description, .product__info-container .product__description');
  const disclaimer = document.querySelector('.ck_disclaimer_wrapper');
  const productInfo = document.querySelector('.product__info-container');

  if (customSteps && whereCustomStepsGo) {
    if (customDesc && productDescription && productDescription.parentNode) {
      productDescription.parentNode.insertBefore(customDesc, productDescription.nextSibling);
    }
    whereCustomStepsGo.parentNode.insertBefore(customSteps, whereCustomStepsGo.nextSibling);
    if (disclaimer && productInfo && productInfo.parentNode) {
      productInfo.parentNode.insertBefore(disclaimer, productInfo.nextSibling);
    }
  }
}

function bindOpenChat() {
  if (window.ckChatBound) return;
  window.ckChatBound = true;

  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('.ck-trigger__chat-link, a.open_chat');
    if (!link) return;

    event.preventDefault();

    if (window.Reamaze && typeof window.Reamaze.popup === 'function') {
      window.Reamaze.popup();
      return;
    }

    const widget =
      document.getElementById('reamaze-widget') ||
      document.querySelector('#reamazejs-container .reamaze-widget') ||
      document.querySelector('#reamazejs-container button') ||
      document.querySelector('#reamazejs-container');

    if (widget) widget.click();
  });
}

function bootCustomKit() {
  bindOpenChat();
  customKit();
  mobileChangeCustomKitElementPlacement();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootCustomKit);
} else {
  bootCustomKit();
}
